var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadStep3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    fill: "none",
    customFrame: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_8",
    x1: 10,
    x2: 35.8461533,
    y1: 24,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(151,87,230)",
    offset: 0,
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(118,56,241)",
    offset: 0.999890745,
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_9",
    x1: 19.9238892,
    x2: 37.7684174,
    y1: 27.2499924,
    y2: 27.2499924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: 0,
    stopOpacity: 0.678212404
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(145,81,232)",
    offset: 1,
    stopOpacity: 0.618471384
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_10",
    x1: 19.9238892,
    x2: 37.7684174,
    y1: 27.2499924,
    y2: 27.2499924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: 0,
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(255,255,255)",
    offset: 1,
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4\\u5408 3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    cx: 24,
    cy: 24,
    r: 24,
    fill: "rgb(141,86,233)",
    fillOpacity: 0.109999999
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copper-coin-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6",
    d: "M22.9231 37C15.7857 37 10 31.1799 10 24C10 16.8201 15.7857 11 22.9231 11C30.0605 11 35.8462 16.8201 35.8462 24C35.8462 31.1799 30.0605 37 22.9231 37ZM22.9231 18.4841L17.4398 24L22.9231 29.5146L28.405 24L22.9231 18.4841Z",
    fill: "url(#paint_linear_8)",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u94B1\\u888B-(1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6",
    d: "M31.2819 23.6009C33.0021 23.6009 34.2759 24.7665 35.224 26.2891C36.7105 28.6766 37.4044 31.9665 37.6547 33.4313L37.6965 33.6839C37.7395 33.9522 37.7622 34.1249 37.7684 34.1736C37.7646 34.8397 37.4904 35.5054 37.0538 35.9977C36.6458 36.4577 36.0931 36.7685 35.4805 36.7685L22.2118 36.7685C21.5992 36.7685 21.0465 36.4577 20.6385 35.9977C20.2019 35.5054 19.9277 34.8396 19.9239 34.1735C19.9602 33.8889 20.5634 29.3483 22.4683 26.2891C23.4164 24.7665 24.6904 23.6009 26.4109 23.6009L31.2819 23.6009ZM24.4612 17.9904C24.6742 17.7735 25.019 17.6833 25.5388 17.7565C26.2091 17.8504 26.6838 18.113 27.125 18.3535C27.6444 18.6367 28.123 18.8884 28.7623 18.8884C29.329 18.8884 29.729 18.6333 30.156 18.3464C30.589 18.0555 31.0565 17.7328 31.8619 17.7586C32.4714 17.778 32.8411 17.8916 33.0519 18.1063C33.3093 18.3684 33.3175 18.7598 33.3177 19.1981C33.2383 19.4188 32.7923 20.6106 32.1372 21.4311C31.8164 21.833 31.4464 22.1622 31.0297 22.1622L26.4109 22.1622C25.9941 22.1622 25.6241 21.833 25.3032 21.4311C24.6028 20.5538 24.1229 19.2378 24.1229 19.2378C24.1229 18.7705 24.1716 18.2854 24.4612 17.9904Z",
    fill: "url(#paint_linear_9)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6",
    d: "M35.224 26.2891C36.7105 28.6766 37.4044 31.9665 37.6547 33.4313L37.6965 33.6839C37.7395 33.9522 37.7622 34.1249 37.7684 34.1736C37.7646 34.8397 37.4904 35.5054 37.0538 35.9977C36.6458 36.4577 36.0931 36.7685 35.4805 36.7685L22.2118 36.7685C21.5992 36.7685 21.0465 36.4577 20.6385 35.9977C20.2019 35.5054 19.9277 34.8396 19.9239 34.1735C19.9602 33.8889 20.5634 29.3483 22.4683 26.2891C23.4164 24.7665 24.6904 23.6009 26.4109 23.6009L31.2819 23.6009C33.0021 23.6009 34.2759 24.7665 35.224 26.2891ZM25.5388 17.7565C26.2091 17.8504 26.6838 18.113 27.125 18.3535C27.6444 18.6367 28.123 18.8884 28.7623 18.8884C29.329 18.8884 29.729 18.6333 30.156 18.3464C30.589 18.0555 31.0565 17.7328 31.8619 17.7586C32.4714 17.778 32.8411 17.8916 33.0519 18.1063C33.3093 18.3684 33.3175 18.7598 33.3177 19.1981C33.2383 19.4188 32.7923 20.6106 32.1372 21.4311C31.8164 21.833 31.4464 22.1622 31.0297 22.1622L26.4109 22.1622C25.9941 22.1622 25.6241 21.833 25.3032 21.4311C24.6028 20.5538 24.1229 19.2378 24.1229 19.2378C24.1229 18.7705 24.1716 18.2854 24.4612 17.9904C24.6742 17.7735 25.019 17.6833 25.5388 17.7565Z",
    fillRule: "nonzero",
    stroke: "url(#paint_linear_10)",
    strokeWidth: 0.463077
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uFFE5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84",
    d: "M25.6277 27.1868L27.7367 31.0645L26.3417 31.0645L26.3417 31.7999L28.1432 31.7999L28.1541 31.8111L28.1541 32.7359L26.3417 32.7359L26.3417 33.4713L28.1541 33.4713L28.1541 35.1428L29.5382 35.1428L29.5382 33.4713L31.3617 33.4713L31.3617 32.7359L29.5382 32.7359L29.5382 31.8111L29.5492 31.7999L31.3617 31.7999L31.3617 31.0645L29.9556 31.0645L32.0647 27.1868L30.5049 27.1868L28.8462 30.5408L27.1875 27.1868L25.6277 27.1868Z",
    fill: "rgb(255,255,255)",
    fillRule: "nonzero"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadStep3);
export default __webpack_public_path__ + "static/media/download-step-3.f2e7eac4e41b01671ca0ea942062d05d.svg";
export { ForwardRef as ReactComponent };